import { useCurrentProjectId } from "lib/hooks/useProject";
import { useUploader } from "lib/hooks/useUploader";
import { useIngressesAndUploads } from "./lib/useIngressesAndUploads";
import { dismissIngress } from "lib/hooks/useDismissIngress";
import UploadSvg from "components/icons/UploadIcons/upload.svg";
import IngressListItem from "./IngressListItem";

export default function IngressJobsDropdown() {
  const projectId = useCurrentProjectId();
  const { pauseFile, resumeFile, retryFile, cancelFile } = useUploader();
  const { ingressesAndUploads } = useIngressesAndUploads();

  const count = ingressesAndUploads?.length ?? 0;

  return (
    <div className="h-80 w-96 overflow-y-auto rounded-lg">
      <div className="sticky top-0 z-10 bg-white px-2 pt-2">
        <div className="flex items-center space-x-4 rounded-md bg-gray-100 p-3.5">
          <UploadSvg className="w-6 text-gray-500" />
          <span className="text-sm text-gray-600">
            Importing {count} asset{count !== 1 && "s"}
          </span>
        </div>
      </div>
      {count > 0 && (
        <div className="space-y-2 px-2 py-4">
          {ingressesAndUploads.map((ingress) => (
            <IngressListItem
              key={ingress.id}
              item={ingress}
              onPause={() => pauseFile(ingress.id)}
              onResume={() => resumeFile(ingress.id)}
              onCancel={() => cancelFile(ingress.id)}
              onRetry={() => retryFile(ingress.id)}
              onDismiss={() =>
                dismissIngress(projectId, parseInt(ingress.id), () =>
                  cancelFile(ingress.id),
                )
              }
            />
          ))}
        </div>
      )}
    </div>
  );
}
